import { jsx as _jsx } from "react/jsx-runtime";
import Drawer from 'components/AntEnhancement/Drawer';
import { useParams } from 'react-router';
import localeTranslator from 'library/Hocs/LocalTranslator';
import services from 'services';
import PatientLog from '../PatientLog';
import '../PatientLog/style.css';
var PatientLogDrawer = function (props) {
    var onClose = function () { return props.onCloseDrawer(); };
    var id = useParams().id;
    var patientId = props.appointment
        ? props.appointment.getPatient().getId()
        : props.patientId;
    var loginData = services.userService.useLoginData().data;
    var placement = (loginData === null || loginData === void 0 ? void 0 : loginData.lang) && (loginData === null || loginData === void 0 ? void 0 : loginData.lang) != 'en' ? 'left' : 'right';
    return (_jsx(Drawer, { placement: placement, open: props.visiable, width: 520, onClose: onClose, closable: false, destroyOnClose: true, className: "patient-log-drawer", styles: { body: { padding: 0 } }, children: patientId != null && (_jsx(PatientLog, { patientId: patientId, appointment: props.appointment, appointmentId: props.appointment ? Number(id) : undefined, onClose: onClose })) }, placement));
};
export default localeTranslator(PatientLogDrawer, 'patientLog');
